import ExportIndex from '@/views/Export';
import ExportFilters from '@/components/Export/Filters';
import ExportSites from '@/components/Export/Sites';
import ExportTransportMode from '@/components/Export/TransportMode';
import ExportSections from '@/components/Export/Sections';
import ExportConfiguration from '@/components/Export/Configuration';

const meta = {
  topbar: true,
  closable: true,
};

export const Routes = [
  {
    path: 'filters',
    name: 'exportFilters',
    component: ExportFilters,
    meta,
  },
  {
    path: 'sites',
    name: 'exportSites',
    component: ExportSites,
    meta,
  },
  {
    path: 'transport-mode',
    name: 'exportTransportMode',
    component: ExportTransportMode,
    meta,
  },
  {
    path: 'sections',
    name: 'exportSections',
    component: ExportSections,
    meta,
  },
  {
    path: 'configuration',
    name: 'exportConfiguration',
    component: ExportConfiguration,
    meta,
  },
];

export const ExportRoute = {
  path: '/export/:studyId',
  name: 'export',
  meta,
  component: ExportIndex,
  children: Routes,
};
